module.exports = __webpack_public_path__ + "img/circle-clock.9c975d78.svg";